import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export function ClusterPickerDialog({ clusterPicker, onClose, onSelect }) {
  return (
    <Dialog open={!!clusterPicker} onOpenChange={(open) => !open && onClose()}>
      <DialogContent data-testid="cluster-picker-dialog" className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-base">Apri documento</DialogTitle>
          <DialogDescription className="text-xs text-zinc-500">
            {clusterPicker?.customer_name ? `Cliente: ${clusterPicker.customer_name}` : clusterPicker?.title}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2 pt-2">
          {clusterPicker?.docs?.map((doc) => {
            const isInv = doc.doc_type === "inventory";
            return (
              <button
                key={`${doc.doc_type}_${doc.doc_id}`}
                type="button"
                data-testid={`cluster-picker-${doc.doc_type}-${doc.doc_id}`}
                onClick={() => onSelect(doc)}
                className="w-full flex items-center justify-between gap-2 p-3 rounded-sm border border-zinc-200 hover:border-zinc-400 hover:bg-zinc-50 transition-colors"
              >
                <div className="flex items-center gap-2">
                  <span className={`text-[10px] px-1.5 py-0.5 rounded-sm ${isInv ? "bg-purple-100 text-purple-700" : "bg-blue-100 text-blue-700"}`}>
                    {isInv ? "Inventario" : "Preventivo"}
                  </span>
                  <span className="text-sm font-medium text-zinc-800">{doc.number || "—"}</span>
                </div>
                <span className="text-zinc-400 text-xs">Apri →</span>
              </button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
